module.exports = __webpack_public_path__ + "img/tour_2_egg_6_riddle.eec3160e.jpg";